import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { JwtModule } from "@auth0/angular-jwt";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { NavBarComponent } from "./components/nav-bar/nav-bar.component";
import { LoginComponent } from "./pages/login/login.component";
import { HTTP_INTERCEPTORS } from "@angular/common/http";

import { UserSettingsComponent } from "./pages/user-settings/user-settings.component";
import { UserCreditHistoryRepository } from "./repositories/credits/user-credit-history-repository";
import { ConnectInmateComponent } from "./components/connect-inmate/connect-inmate.component";
import { SignUpComponent } from "./pages/sign-up/sign-up.component";

// Shared
import { PhotoRepository as PhotoRepository, JhmHttpInterceptor, JhmHttpInterceptorConfig,
	NavigationService, PhotoUploadService, PurchaseRepository,
	SharedContactRepository, SharedPendingCivilianContactRepository, SharedLoginRepository, SharedMessageRepository,
	SharedMessageRepositoryTable, SharedModule, SharedPasswordRepository,
	SharedUserLinkingRepository,
	InmateSecureDocumentCountRepository} from "@shared/src/public-api";
import { CivilianRegistrationRepository } from "./repositories/registration/civilian-registration-repository";
import { CivilianJurisdictionRepository } from "./repositories/jurisdictions/civilian-jurisdiction-repository";
import { LayoutModule } from "@angular/cdk/layout";
import { environment } from "../environments/environment";
import { GeneralRepository } from "./repositories/general/general-repository";
import { CivilianSettingsRepository } from "./repositories/settings/user-credit-history-repository";
import { SubscriptionComponent } from "./pages/subscription/subscription.component";
import { CivilianEmailSubscriptionRepository } from "./repositories/subscription/civilian-subscription-repository";

@NgModule({
	declarations: [AppComponent],
	imports: [
		SharedModule,
		BrowserModule,
		AppRoutingModule,
		FormsModule,
		ReactiveFormsModule,
		LayoutModule,
		JwtModule.forRoot({
			config: {
				tokenGetter: () => {
					return localStorage.getItem("access_token");
				},
				allowedDomains: ["localhost:8080", "jailhousemail.com"]
			}
		}),
		NavBarComponent,
		LoginComponent,
		UserSettingsComponent,
		ConnectInmateComponent,
		SignUpComponent,
		SubscriptionComponent
	],
	providers: [
		{ provide: LocationStrategy, useClass: HashLocationStrategy },
		{ provide: JhmHttpInterceptorConfig, useValue: new JhmHttpInterceptorConfig("civilian", "CIVILIAN", environment) },
		{ provide: HTTP_INTERCEPTORS, useClass: JhmHttpInterceptor, multi: true },
		PurchaseRepository,
		CivilianRegistrationRepository,
		CivilianJurisdictionRepository,
		NavigationService,
		UserCreditHistoryRepository,
		SharedMessageRepository,
		SharedContactRepository,
		InmateSecureDocumentCountRepository,
		SharedPasswordRepository,
		SharedLoginRepository,
		SharedMessageRepositoryTable,
		SharedPendingCivilianContactRepository,
		SharedUserLinkingRepository,
		PhotoUploadService,
		PhotoRepository,
		GeneralRepository,
		CivilianSettingsRepository,
		CivilianEmailSubscriptionRepository
	],
	bootstrap: [AppComponent]
})
export class AppModule
{ }
